/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import { string, bool } from 'prop-types';
import React from 'react';

import BaseModal from '../Modal/BaseModal';

import Disclosure from './Disclosure';

export default class DisclosureModal extends BaseModal {
  containerClassName() {
    return (
      'modal-info-container modal-disclosure-container ' +
      (this.props.className || '')
    );
  }

  renderLinkContent() {
    return this.props.hideLinkContent ? null : 'Important Information';
  }

  renderModalContent() {
    return <Disclosure content={this.props.content} />;
  }
}

DisclosureModal.propTypes = {
  className: string,
  content: string,
  hideLinkContent: bool,
  iconAfter: bool
};

DisclosureModal.defaultProps = {
  hideLinkContent: false,
  iconAfter: false
};
